export default __webpack_public_path__ + "static/media/3CX-partner-logo-hd.ceec2785.jpg";